export default function (totalCharge, quantity, card) {
  if (typeof TTDUniversalPixelApi === "function") {
    var universalPixelApi = new TTDUniversalPixelApi();
    universalPixelApi.init(
      "aszns79",
      ["e187lw7"],
      "https://insight.adsrvr.org/track/up",
      {
        td1: card?.id,
        td2: quantity,
        v: totalCharge,
      }
    );
  }

  fbq("track", "Purchase", {
    value: totalCharge,
    currency: "USD",
    order_id: card.id,
    content_ids: card.id,
    content_type: "product",
  });
}
